module.exports = "<div id=\"spinnerComp\">\n  <!--<div style=\"width: 120px;height: 120px;margin: 0 auto\" class=\"loader-wrapper\">\n    <div class='loader loader1'></div>\n    \n    <h2 style=\"margin-top: 10px;text-align: center\">Loading</h2>\n  </div>-->\n<div style=\"width: 50px;height: 120px;margin: 0 auto\" class=\"loader-wrapper\">\n<div class='loader loader1'>\n  <div></div>\n</div>\n</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/spinner.component/spinner.component.html
// module id = 557
// module chunks = 2